export const DirectorsData = [
    {
        name: "Hilda Pretty",
        title: "Registered Nurse",
        img: "/images/hilda-pretty.jpg",
        alt: "picture of hilda pretty",
    },
    {
        name: "Tobi Thompson",
        title: "Accounts Payable Manager",
        img: "/images/tobi-tompson.jpg",
        alt: "picture of tobi tompson",
    },
    {
        name: "Tommy Seawright",
        title: "Board Member",
        img: "/images/tommy-seawright.jpg",
        alt: "picture of tommy seawright",
    },
    {
        name: "Rhonda Kuszak",
        title: "Legal Office Assistant",
        img: "/images/rhonda-kuszak.jpg",
        alt: "picture of rhonda kuszak",
    },
]